import React, { FC } from "react";

export const Caution: FC = (props) => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<circle cx="12" cy="12" r="12" fill="#E30613" />
		<path
			d="m11.326 12.832-.254-3.821C11.022 8.265 11 7.73 11 7.404c0-.441.116-.789.347-1.035.232-.246.536-.369.912-.369.456 0 .767.16.92.478.151.318.23.774.23 1.367 0 .355-.02.71-.057 1.071l-.34 3.93c-.036.47-.116.825-.239 1.078a.626.626 0 0 1-.608.377c-.29 0-.485-.123-.6-.362-.11-.246-.189-.615-.24-1.107Zm.89 5.246c-.326 0-.608-.101-.847-.31-.239-.21-.362-.508-.362-.884 0-.333.116-.608.348-.84.231-.23.513-.347.846-.347.333 0 .623.116.861.348.24.231.355.514.355.84 0 .368-.123.665-.362.875a1.218 1.218 0 0 1-.84.318Z"
			fill="#fff"
		/>
	</svg>
);
